import { hostOf } from './app-surface';

/**
 * Point `<link rel="canonical">` at this surface's own origin.
 *
 * `index.html` ships the tag with an empty href, which a browser -- and a
 * crawler -- resolves self-referentially, query string and all. The bundle is
 * served on two hosts, so the canonical address is whichever host is actually
 * serving this path (design doc, §8.3).
 *
 * Called from both bootstraps. The browser one (`main.ts`) runs before
 * `bootstrapApplication`; the server one runs during it, because
 * server-rendered HTML is what a crawler reads first and it used to carry the
 * empty value.
 *
 * The origin is checked with `hostOf` rather than used blind: these values come
 * from a gitignored environment file edited by hand on the deploy host, and a
 * canonical pointing at nothing is worse than the one already in the template.
 */
export function setCanonicalHref(document: Document, origin: string, pathname: string): void {
  if (!hostOf(origin)) {
    return;
  }
  const link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    return;
  }
  // A canonical names a page, not a request: no query string, no fragment.
  const path = pathname.split(/[?#]/)[0] || '/';
  link.setAttribute('href', `${origin}${path.startsWith('/') ? path : `/${path}`}`);
}
